function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  id: "a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.56 9.434c.66.714.551 1.963-.223 2.794-.441.445-1.555 1.18-2.539.294v.866c0 .326-.25.595-.552.595H.552c-.303 0-.552-.27-.552-.595V1.677c0-.327.249-.595.552-.595h1.934V.605c0-.326.249-.594.552-.594h3.727c.303 0 .552.268.552.594v.477h1.932c.302 0 .551.268.551.595v4.786l2.76 2.97zM3.59 1.17v1.01h2.621v-1.01H3.59zM1.077 12.82v.004h7.617V11.34L6.32 8.782c-.083-.088-.138-.177-.138-.297l-.47-2.734c-.053-.603.435-.731.608-.654l2.374.47V2.272h-1.38v.503c-.026.296-.275.566-.551.566H3.038c-.303 0-.552-.27-.552-.595v-.474H1.077v10.55zm10.488-1.424c.387-.418.414-.923.223-1.132L8.477 6.7l-1.574-.327.303 1.723 3.282 3.538c.39.297.856-.03 1.077-.237z",
  id: "b"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3283C8",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b",
  transform: "translate(5 3)"
}))));